import React, {useState} from 'react'
import PickupTimeEstimate from './PickupTimeEstimate'
import CustomerPickupEstimate from './CustomerPickupEstimate'
import firebase from '../../firebase'
import {Button} from "@blueprintjs/core"


import './index.scss'
import {TEMP_SUPPORTED_SHOPS} from '../scheduledDelivery'


export default function OrderItemsTodoList ({snapshot, settings={}}) {
  const [sendOptionalPostmates, setSendOptionalPostmates] = useState(false)

  const {delivery={}, enablePickupEstimatePicker} = settings
  // console.log('asdf', settings)
  let {selfDeliveryWithOptionalPostmates, deliverWithPostmates} = delivery
  if (!!snapshot.child('pickupReadyTS').val()) {
    selfDeliveryWithOptionalPostmates = false
  }

  const id = snapshot.key
  const {r_id, cartType} = snapshot.val()
  const notify_id = `${id}${r_id}`
  const notifyRef = firebase.database().ref(`notify`).child(notify_id)

  let shoudShowPickupEstimate = enablePickupEstimatePicker && ((cartType === 'PICKUP') || (cartType === 'DINEIN'))

  let shouldShowEstimate =
    ((TEMP_SUPPORTED_SHOPS.indexOf(r_id) !== -1) || deliverWithPostmates) &&
    (cartType === 'DELIVERY')

  const isAccepted  = !!snapshot.child('orderAcceptedByShop').val()
  const hasEstimate = !!snapshot.child('pickupReadyTS').val() || !!snapshot.child('doNotDispatch').val()
  if (selfDeliveryWithOptionalPostmates && !sendOptionalPostmates) {
    shouldShowEstimate = false
  }
  let complete = (shouldShowEstimate || shoudShowPickupEstimate) ? hasEstimate : isAccepted
  // if (shoudShowPickupEstimate)
  const completeClass = complete ? ' complete' : ''

  return (
      <section className={"order-item-todos pane" + completeClass}>
        <header className="todo-list-header">
          <h2>{complete ? "Completed Actions" : "Need Action"}</h2>
        </header>

        {shoudShowPickupEstimate ? <CustomerPickupEstimate snapshot={snapshot}></CustomerPickupEstimate> : null}

        {selfDeliveryWithOptionalPostmates && !sendOptionalPostmates && (cartType === 'DELIVERY') &&
          <div>
            <div className="todo-item">
              <Button onClick={() => snapshot.ref.update({orderAcceptedByShop: true})}
                large
                intent={isAccepted ? "success" : "none"}
                icon="tick">Accept & Deliver with Restaurant's Driver</Button>


              </div>
              <div className="todo-item">
                <Button onClick={() => setSendOptionalPostmates(true)}
                  large
                  icon="drive-time"
                  intent="warning"
                  >Request Freelance Driver</Button>
              </div>
          </div>
        }

        {(!shoudShowPickupEstimate && !shouldShowEstimate && !selfDeliveryWithOptionalPostmates) ? <div className="todo-item">
          <Button onClick={() => snapshot.ref.update({orderAcceptedByShop: true})}
            large
            intent={isAccepted ? "success" : "none"}
            icon="tick">Accept Order</Button>
          </div> : null}

          {shouldShowEstimate ?
            <PickupTimeEstimate snapshot={snapshot} settings={settings} /> : null}

          {shouldShowEstimate && selfDeliveryWithOptionalPostmates &&
            <div className="todo-item">
              <Button
                onClick={() => setSendOptionalPostmates(false)}
                large
                intent="warning"
                >
                Cancel
                </Button>
            </div>
          }
          </section>
        )

}
